import { useFormikContext } from 'formik';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import React, { memo, useContext, useEffect, useState } from 'react';
import { QuoteContext } from '../../../contexts/Quote';
import { Blok } from '../../../interfaces/Blok.interface';
import { FormSectionBlokProps } from '../FormSectionBlok.interface';

interface PersonalDetailsReviewAndEditFormSectionBlokProps
  extends FormSectionBlokProps {
  edit_button_label: string;
  close_edit_button_label: string;
}

interface PersonalDetailsReviewAndEditFormSectionProps {
  blok: PersonalDetailsReviewAndEditFormSectionBlokProps;
}

interface FormikValues {
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  title: string;
}

const PersonalDetailsReviewAndEditFormSection: React.FC<
  PersonalDetailsReviewAndEditFormSectionProps
> = ({ blok }) => {
  const {
    heading,
    edit_button_label,
    close_edit_button_label,
    form_fields,
    sectionNumber,
  } = blok;

  const formik = useFormikContext<FormikValues>();
  const { quoteDetails } = useContext(QuoteContext);
  const customerDetails = quoteDetails?.customerDetails;
  const [isEditingForm, setIsEditingForm] = useState<boolean>(false);

  useEffect(() => {
    if (
      formik.errors?.firstName ||
      formik.errors?.lastName ||
      formik.errors?.email ||
      formik.errors?.telephone ||
      formik.errors?.title
    ) {
      setIsEditingForm(true);
    }
  }, [formik.isValid]);

  return (
    <section
      {...storyblokEditable(blok)}
      className="mx-3.5 py-12 border-b border-b-border/default sm:mx-0"
    >
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start text-2xl gap-x-4">
            <div className="w-9 h-9 rounded-full bg-icon/icon-active-bg flex items-center justify-center">
              <p className="text-system/white font-dm-serif-display">
                {sectionNumber}
              </p>
            </div>
            <p className="text-text/body font-dm-serif-display">{heading}</p>
          </div>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setIsEditingForm(!isEditingForm);
            }}
            className="inline-flex justify-center items-center leading-none transition-all ease-in-out duration-300 cursor-pointer py-3 px-8 text-md focus:ring-0 focus:outline-none fit-content uppercase rounded-full font-bold border no-underline border-button/outline-border hover:border-button/outline-bg-hover text-button/outline-label hover:text-button/outline-label-hover bg-transparent hover:bg-button/outline-bg-hover"
          >
            {isEditingForm ? close_edit_button_label : edit_button_label}
          </button>
        </div>
        {!isEditingForm && (
          <div className="space-y-6 text-text/body">
            <p>
              {customerDetails?.firstName + ' ' + customerDetails?.lastName}
            </p>
            <p>{customerDetails?.email}</p>
            <p>{customerDetails?.telephone}</p>
          </div>
        )}
        {isEditingForm && (
          <div className="space-y-12">
            {form_fields.map((formField: Blok) => (
              <StoryblokComponent blok={formField} key={formField._uid} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default memo(PersonalDetailsReviewAndEditFormSection);
